import styled from '@emotion/styled';

import { commonColors } from 'application/theme';
import { colors } from 'application/theme/palette';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 40px 16px;
  background-color: ${commonColors.white};

  h1 {
    color: ${commonColors.black};
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
    margin-bottom: 8px;
  }

  p {
    color: ${commonColors.grey900};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.08px;
    margin-bottom: 32px;
  }
`;

export const ImageWrapper = styled('div')`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    position: absolute;
    width: 98px;
    height: 88px;
  }

  img {
    opacity: 0.3;
  }
`;

export const Image = styled('div')`
  width: 100%;
  height: auto;
  background: lightgray;
  opacity: 0.5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  border-radius: 16px;
`;

export const LogOutButton = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;

  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${colors.blue700};
  font-family: 'Unica77';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0.08px;
`;

export const ButtonsSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  > a {
    width: 100%;
    text-decoration: none;
    button {
      height: 56px;
      width: 100%;
    }
  }
`;
